

















import Vue from "vue";
import AutomaticLoginForm from "@/components/AutomaticLoginForm.vue";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { SET_PROGRESS } from "@/constants/mutation-types";

export default Vue.extend({
  name: "client-zone-login",
  data() {
    return {
      time: 17 as number,
      showSecondHeader: false,
      TRANSLATION_KEY: "steps.ClientZoneLogin",
    };
  },
  mounted(): void {
    this.$store.commit(SET_PROGRESS, 3);
    setTimeout(() => {
      this.time = 0;
    }, this.time * 1000);
    setTimeout(() => {
      this.showSecondHeader = true;
    }, 10000);
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper;
    },
  },
  components: {
    AutomaticLoginForm,
  },
});
